module.exports = __webpack_public_path__ + "static/media/comment-alt-music.7ca8fbfc.svg";